export default __webpack_public_path__ + "static/media/@schturdy.5c837ea6.jpeg";